import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { Subject, takeUntil } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

interface FoodNode {
  name: string;
  key?: string;
  children?: FoodNode[];
  navigate: string;
  expandable?: boolean;
}

const TREE_DATA: FoodNode[] = [
  {
    name: 'Company Profiling',
    key: 'b2b.managecompany.companyprofiling',
    children: [
      {
        name: 'Company details',
        key: 'b2b.managecompany.cdcompanydetails',
        navigate: '/cam/company-management/company-details',
      },
      {
        name: 'Office location information',
        key: 'b2b.managecompany.officelocationinformation',
        navigate: '/cam/company-management/branch-information',
      },
      {
        name: 'Cost center overview',
        key: 'b2b.managecompany.bicostcenteroverview',
        navigate: '/cam/company-management/cost-center-overview',
      },
      {
        name: 'Project details',
        key: 'b2b.managecompany.pdprojectdetails',
        navigate: '/cam/company-management/project-details',
      },
      {
        name: 'Corporate cards',
        key: 'b2b.managecompany.cccorporatecards',
        navigate: '/cam/company-management/corporate-cards',
      },
      {
        name: 'Business unit overview',
        key: 'b2b.managecompany.buotitle',
        navigate: '/cam/company-management/business-unit-overview',
      },
    ],
    navigate: '/cam/company-management',
    expandable: true,
  },
  {
    name: 'Traveler Profiling',
    key: 'b2b.managecompany.travelerprofiling',
    children: [
      { name: 'Department', key: 'b2b.managecompany.department', navigate: '/cam/traveler-profile/department' },
      { name: 'Designation', key: 'b2b.managecompany.ccdesignation', navigate: '/cam/traveler-profile/designation' },
      {
        name: 'Employee grade',
        key: 'b2b.managecompany.ccemployeegrade',
        navigate: '/cam/traveler-profile/employeegrade',
      },
      {
        name: 'Travel category',
        key: 'b2b.managecompany.tptravelcategory',
        navigate: '/cam/traveler-profile/travel-category',
      },
    ],
    navigate: '/cam/traveler-profile',
    expandable: false,
  },
  {
    name: 'Other misc. functionality',
    key: 'b2b.managecompany.othermiscfunctionality',
    children: [
      {
        name: 'Company settings',
        key: 'b2b.managecompany.omfcompanysettings',
        navigate: '/cam/other-misc-func/company-setting',
      },
      {
        name: 'Enable company login',
        key: 'b2b.managecompany.omfenablecompanylogin',
        navigate: '/cam/other-misc-func/enable-company-login',
      },
      {
        name: 'Change email domain',
        key: 'b2b.managecompany.omfchangeemaildomain',
        navigate: '/cam/other-misc-func/change-email-domain',
      },
    ],
    navigate: '',
    expandable: false,
  },
];
@Component({
    selector: 'app-menu-nav-expanded',
    templateUrl: './menu-nav-expanded.component.html',
    styleUrls: ['./menu-nav-expanded.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, MatIconButton, MatIcon, NgIf, RouterLinkActive, RouterLink]
})
export class MenuNavExpandedComponent {
  dataSource: FoodNode[];
  private readonly destroy$ = new Subject<void>();
  content: any;
  constructor(
    private readonly router: Router,
    private readonly _CompanyManagementService: CompanyManagementService,
    private readonly contentService: CompanyManagementContentService,
  ) {
    this.contentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
      });
    this.dataSource = TREE_DATA;
    const currentUrl = this.router.url;
    this.dataSource.forEach((node) => {
      const isActive = node.children?.some(
        (child) => child.navigate === currentUrl
      );
      node.expandable = !!isActive;
    });
  }

  companyManagement(clickedNode: any) {
    console.log("clickedNode", clickedNode)
    this.dataSource.forEach(node => {
      if (node === clickedNode) {
        node.expandable = !node.expandable;
      } else {
        node.expandable = false;
      }
    });

    this._CompanyManagementService.company_management_MenuClick();
  }


  onChildClick(event: Event, child: any) {
    event.stopPropagation(); // 👈 prevents collapsing
    this._CompanyManagementService.company_menu_click(child.name);
  }
}
